import { render } from "./SnackbarView.vue?vue&type=template&id=2b70d682"
import script from "./SnackbarView.vue?vue&type=script&lang=js"
export * from "./SnackbarView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__